// The AI 助手's state, shared by its two ways in — the round button at the
// bottom right (AssistantHost) and the cell in the navbar beside the
// search box (AssistantNavButton) — which open one panel: under the
// navbar when opened from there, at the bottom right otherwise. Which of
// them show is the admin's choice (placement: float, navbar or both).
import { reactive } from 'vue'
import { assistantApi, type AssistantInfo } from '@/api/assistant'

export type AssistantFrom = 'float' | 'navbar'

export const assistant = reactive<{ info: AssistantInfo | null; open: boolean; from: AssistantFrom }>({
  info: null,
  open: false,
  from: 'float',
})

export async function loadAssistant() {
  try {
    assistant.info = await assistantApi.info()
  } catch {
    assistant.info = null
  }
}

/** What the console calls it: the admin's name for the console's language,
    else its own (fallback). */
export function assistantName(info: AssistantInfo | null | undefined, locale: string, fallback: string): string {
  return (locale.startsWith('en') ? info?.name_en : info?.name) || fallback
}

/** Whether the assistant is offered there. */
export function offered(where: AssistantFrom): boolean {
  const i = assistant.info
  if (!i?.enabled) return false
  const p = i.placement || 'float'
  return p === 'both' || p === where
}

/** Opens the panel from where, or closes it when it is open from there. */
export function toggleAssistant(where: AssistantFrom) {
  if (assistant.open && assistant.from === where) {
    assistant.open = false
    return
  }
  assistant.from = where
  assistant.open = true
}
